import { Box, styled } from "@mui/material";

export const QuestionsListContainer = styled(Box)`
	height: 100%;
	margin-top: 20px;
	display: flex;
	flex-grow: 1;
	flex-direction: column;
	flex-wrap: nowrap;
	align-content: center;
	justify-content: center;
	align-items: center;
`;
